import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../../redux/actions/menuActions";

import Menu from "../Menu.basepdc";
import RequestsList from "../../../containers/metier/requests/RequestsList";

class RequestsPdcs extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("basepdc");
    this.props.setMenuLeftContent(Menu);
    this.props.setMenuLeftIndex("requests");
    this.props.setMenuLeftItemIndex("");
  }

  render() {
    return <RequestsList token={this.props.token}/>;
  }
}
const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    setMenuLeftContent: content => {
      dispatch(setMenuLeftContent(content));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RequestsPdcs);



// WEBPACK FOOTER //
// src/pages/basepdc/requestsPdcs/Home.requestspdcs.js